import { render, staticRenderFns } from "./base-modal.vue?vue&type=template&id=b4519dc2&scoped=true"
import script from "./base-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./base-modal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-modal.vue?vue&type=style&index=0&id=b4519dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4519dc2",
  null
  
)

export default component.exports